import { Routes, Route, useLocation } from "react-router-dom";
import { useState, useCallback } from "react";
import { useBodyClasses } from "./hooks/useBodyClasses";
import AppHeader from "./components/Header/Header";
import WhiteNavbar from "./components/Header/WhiteNavbar";
import MobileMenu from "./components/Header/MobileMenu";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import DecorativeBackground from "./components/DecorativeBackground";
import ThreeDPrintingPage from "./menus/Home/3DPrinting";
import ContactPage from "./menus/Contact";
import AboutUs from "./menus/Pages/Aboutus";
import Shop from "./menus/Shop/ProductList/shop";
import ProductDetail from "./menus/Shop/ProductList/ProductDetail";
import { useApp } from "./contexts/AppContext";

const AppContent = () => {
  const { products } = useApp();
  const location = useLocation();
  useBodyClasses();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isContactPage = location.pathname === "/contact";
  const printingServices = location.pathname === "/printing-services";
  const blogsAndTutorial = location.pathname === "/blogs-and-tutorial";

  const openMobileMenu = useCallback(() => setIsMobileMenuOpen(true), []);
  const closeMobileMenu = useCallback(() => setIsMobileMenuOpen(false), []);
  const blogStandard = location.pathname === "/blog-standard";
  const blogList = location.pathname === "/blog-list";
  const blogPortfolio = location.pathname === "/blog-portfolio";
  const blogGrid = location.pathname === "/blog-grid";
  const singlePostStandard = location.pathname === "/blog/single-post/standard";
  const singlePostWithoutSidebar = location.pathname === "/blog/single-post/without-sidebar";
  const wishlistPage = location.pathname === "/wishlist-page";
  const productSingle = location.pathname === "/product-single";
  // const productList = location.pathname === "/shop";
  const productShop2 = location.pathname.startsWith("/shop");
  const productDetail = location.pathname.startsWith("/shop/") && location.pathname !== "/shop";
  const checkout = location.pathname === "/checkout";

  // Define routes that should show the decorative background and title section
  const showDecorativeLayout = [
    "/about-us",
    "/our-services",
    "/our-team",
    "/faq",
    "/pricing",
    "/portfolio-list",
    "/portfolio-grid",
    "/portfolio-masonry",
    "/portfolio-fullwidth",
    "/portfolio-horizontal",
    "/shop",
    "/blog-standard",
    "/blog-list",
    "/blog-portfolio",
    "/blog-grid",
    "/wishlist-page",
    "/blog/single-post/standard",
    "/blog/single-post/without-sidebar",
    "/product-single",
    "/checkout"
  ].includes(location.pathname) || location.pathname.startsWith("/portfolio/") || location.pathname.startsWith("/shop");

  // Get page title and breadcrumb text based on route
  const getPageInfo = () => {
    // Handle dynamic portfolio routes
    if (location.pathname.startsWith("/portfolio/")) {
      const slug = location.pathname.split("/portfolio/")[1];
      const title = slug.split("-").map(word =>
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(" ");
      return {
        title: title,
        breadcrumb: "Portfolio > " + title
      };
    }

    switch (location.pathname) {
      case "/about-us":
        return { title: "About Us", breadcrumb: "About Us" };
      case "/our-services":
        return { title: "Our Services", breadcrumb: "Our Services" };
      case "/our-team":
        return { title: "Our Team", breadcrumb: "Our Team" };
      case "/faq":
        return { title: "FAQ", breadcrumb: "FAQ" };
      case "/pricing":
        return { title: "Pricing", breadcrumb: "Pricing" };
      case "/blog-standard":
        return { title: "Blog Standard", breadcrumb: "Blog Standard" };
      case "/blog-list":
        return { title: "Blog List", breadcrumb: "Blog List" };
      case "/blog-portfolio":
        return { title: "Blog Portfolio", breadcrumb: "Blog Portfolio" };
      case "/blog-grid":
        return { title: "Blog Grid", breadcrumb: "Blog Grid" };
      case "/portfolio-list":
        return { title: "Portfolio List", breadcrumb: "Portfolio List" };
      case "/portfolio-grid":
        return { title: "Portfolio Grid", breadcrumb: "Portfolio Grid" };
      case "/portfolio-masonry":
        return { title: "Portfolio Masonry", breadcrumb: "Portfolio Masonry" };
      case "/portfolio-fullwidth":
        return { title: "Portfolio Fullwidth", breadcrumb: "Portfolio Fullwidth" };
      case "/portfolio-horizontal":
        return { title: "Portfolio Horizontal", breadcrumb: "Portfolio Horizontal" };
      case "/wishlist-page":
        return { title: "Wishlist Page", breadcrumb: "Wishlist Page" };
      case "/product-single":
        return { title: "Shop", breadcrumb: "Shop" };
      case "/shop":
        return { title: "Shop", breadcrumb: "Shop" };
      case "/checkout":
        return { title: "Shop", breadcrumb: "Shop" };
      default:
        if (location.pathname.startsWith("/shop/")) {
          const id = location.pathname.split("/shop/")[1];
          const product = products.find((p: any) => String(p.id) === id);
          const title = product ? product.name : "Product Detail";
          return { title: "Shop", breadcrumb: `Shop -  ${title}` };
        }
        return { title: "About Us", breadcrumb: "About Us" };
    }
  };

  const pageInfo = getPageInfo();
  const needsMargin70 = [
    "/about-us",
    "/our-services",
    "/our-team",
    "/faq",
    "/pricing",
    "/portfolio-list",
    "/portfolio-grid",
    "/portfolio-masonry",
    "/portfolio-fullwidth",
    "/portfolio-horizontal",
  ].includes(location.pathname) || location.pathname.startsWith("/portfolio/");

  return (
    <>
      <div className="body_wrap extra_bg_layout">
        <div className="page_wrap">
          {isContactPage || printingServices || blogsAndTutorial ? (
            <>
              <WhiteNavbar show={true} onMobileMenuOpen={openMobileMenu} />
              <MobileMenu isOpen={isMobileMenuOpen} onClose={closeMobileMenu} />
            </>
          ) : (
            <AppHeader />
          )}
          {showDecorativeLayout && (
            <>
              <DecorativeBackground />
              {(!singlePostStandard || !singlePostWithoutSidebar) && (
                <>
                  <div data-elementor-type="cpt_layouts" data-elementor-id="16729" className="elementor elementor-16729">
                    <section className="elementor-section elementor-top-section elementor-element elementor-element-375f312 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="375f312" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-extended">
                        <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-fc996a0 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="fc996a0" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="sc_layouts_item elementor-element elementor-element-c0ecf69 sc_height_large sc_layouts_hide_on_notebook sc_layouts_hide_on_tablet sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="c0ecf69" data-element_type="widget" data-widget_type="spacer.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-spacer">
                                  <div className="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                            <div className="sc_layouts_item elementor-element elementor-element-f754336 sc_layouts_hide_on_wide sc_layouts_hide_on_desktop sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="f754336" data-element_type="widget" data-widget_type="spacer.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-spacer">
                                  <div className="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                            <div style={needsMargin70 ? { margin: 70 } : undefined} className="sc_layouts_item elementor-element elementor-element-2c8db0b sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="2c8db0b" data-element_type="widget" data-widget_type="trx_sc_layouts_title.default">
                              <div className="elementor-widget-container">
                                <div className="sc_layouts_title sc_align_center with_content without_image without_tint">
                                  <div className="sc_layouts_title_content">
                                    <div className="sc_layouts_title_title">
                                      <h1 className="sc_layouts_title_caption">{pageInfo.title}</h1>
                                    </div>
                                    <div className="sc_layouts_title_breadcrumbs">
                                      <div className="breadcrumbs">
                                        <a className="breadcrumbs_item home underline_hover" href="/">Home</a>
                                        <span className="breadcrumbs_delimiter"></span>
                                        <span className="breadcrumbs_item current">{pageInfo.breadcrumb}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div> </>)
              }
            </>
          )}
          <div className="page_content_wrap">
            {singlePostStandard && (
              <>
              </>)}
            <div className={`${blogStandard || blogList || productSingle || (productShop2 && !productDetail) || checkout || blogPortfolio || blogGrid || wishlistPage || singlePostStandard || singlePostWithoutSidebar || location.pathname.startsWith("/portfolio/") ? "content_wrap" : (productDetail ? "product_detail_wrap" : "content_wrap_fullscreen")} ${productShop2 ? "shop_full_width" : ""}`}>
              <div className="content">
                <Routes>
                  <Route path="/" element={<ThreeDPrintingPage />} />
                  <Route path="/3d-printing" element={<ThreeDPrintingPage />} />
                  {/* <Route path="/shop" element={<ProductListView />} /> */}
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/about-us" element={<AboutUs />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/shop/:productId" element={<ProductDetail />} />
                </Routes>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ScrollToTop />
    </>
  );
};

const App = () => (
  <AppContent />
);

export default App;
